import { gsap } from 'gsap'

class SwipeGuide {
  constructor(el) {
    this.dom = {el: el};

    this.release = this.release.bind(this);

    this.init();
  }

  init() {
    this.dom.el.addEventListener('click', this.release);
  }

  release(e) {
    gsap.to(e.currentTarget, {
      opacity: 0,
      duration: .9,
      onComplete: () => {
        this.dom.el.remove();
      }
    })
  }
}

export default SwipeGuide